/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPNOTAXNUMBERREASON } from './IAPNOTAXNUMBERREASON';
import {
    IAPNOTAXNUMBERREASONFromJSON,
    IAPNOTAXNUMBERREASONFromJSONTyped,
    IAPNOTAXNUMBERREASONToJSON,
} from './IAPNOTAXNUMBERREASON';

/**
 * 
 * @export
 * @interface TaxViewModel
 */
export interface TaxViewModel {
    /**
     * 
     * @type {number}
     * @memberof TaxViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TaxViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof TaxViewModel
     */
    taxNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof TaxViewModel
     */
    yearEndMonthId?: number;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof TaxViewModel
     */
    countryId?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPNOTAXNUMBERREASON}
     * @memberof TaxViewModel
     */
    taxNumberOverrideReason?: IAPNOTAXNUMBERREASON;
    /**
     * 
     * @type {boolean}
     * @memberof TaxViewModel
     */
    isPrimaryTaxResidency?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaxViewModel
     */
    taxInformationUnAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaxViewModel
     */
    taxInformationUnavailableReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaxViewModel
     */
    isWithholdingInterestOnTax?: boolean;
}

/**
 * Check if a given object implements the TaxViewModel interface.
 */
export function instanceOfTaxViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TaxViewModelFromJSON(json: any): TaxViewModel {
    return TaxViewModelFromJSONTyped(json, false);
}

export function TaxViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'taxNumber': !exists(json, 'TaxNumber') ? undefined : json['TaxNumber'],
        'yearEndMonthId': !exists(json, 'YearEndMonthId') ? undefined : json['YearEndMonthId'],
        'countryId': !exists(json, 'CountryId') ? undefined : IAPCOUNTRYFromJSON(json['CountryId']),
        'taxNumberOverrideReason': !exists(json, 'TaxNumberOverrideReason') ? undefined : IAPNOTAXNUMBERREASONFromJSON(json['TaxNumberOverrideReason']),
        'isPrimaryTaxResidency': !exists(json, 'IsPrimaryTaxResidency') ? undefined : json['IsPrimaryTaxResidency'],
        'taxInformationUnAvailable': !exists(json, 'TaxInformationUnAvailable') ? undefined : json['TaxInformationUnAvailable'],
        'taxInformationUnavailableReason': !exists(json, 'TaxInformationUnavailableReason') ? undefined : json['TaxInformationUnavailableReason'],
        'isWithholdingInterestOnTax': !exists(json, 'IsWithholdingInterestOnTax') ? undefined : json['IsWithholdingInterestOnTax'],
    };
}

export function TaxViewModelToJSON(value?: TaxViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PartyId': value.partyId,
        'TaxNumber': value.taxNumber,
        'YearEndMonthId': value.yearEndMonthId,
        'CountryId': IAPCOUNTRYToJSON(value.countryId),
        'TaxNumberOverrideReason': IAPNOTAXNUMBERREASONToJSON(value.taxNumberOverrideReason),
        'IsPrimaryTaxResidency': value.isPrimaryTaxResidency,
        'TaxInformationUnAvailable': value.taxInformationUnAvailable,
        'TaxInformationUnavailableReason': value.taxInformationUnavailableReason,
        'IsWithholdingInterestOnTax': value.isWithholdingInterestOnTax,
    };
}

